import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import CopyToClipboard from "react-copy-to-clipboard"
import { connect } from "react-redux"
import { Link } from "gatsby"
import { useTimelineEventData } from "../TimelineEventDataProvider"
import {
  InlineHelpTip,
  TransferHelpTip,
  InlineHelpTipsContainer,
} from "./styled/HelpTip"
import Paragraph from "../Paragraph"
import { getRoute } from "../../helpers/routing"
import { TxlGhostButton } from "../TxlButton"
import { SimpleLink } from "../TxlLink"

const ClickCaptureHelpTip = ({ promo, component, children }) => {
  const Component = component

  return (
  <Component $promo={promo}
    onClick={e => {
      // Prevent that a click on the help tip counts as click on the transfer bubble
      e.stopPropagation()
    }}
  >
    {children}
  </Component>
)}

ClickCaptureHelpTip.propTypes = {
  promo: PropTypes.bool,
  component: PropTypes.elementType.isRequired,
  children: PropTypes.node.isRequired,
}

const ConfirmedTransferHelpTips = ({ hasSubscription, inline }) => {
  const event = useTimelineEventData()

  const shareUrl = event.transferData?.shareUrl
  const isFinished = event.transferData?.isFinished
  const isSharedLink = event.transferData?.details?.shareMethod === "link"

  const {
    t,
    i18n: { language },
  } = useTranslation("generic")

  const WrapperComponent = inline ? InlineHelpTipsContainer : "div"

  return (
    <WrapperComponent>
      {isSharedLink && (
        <ClickCaptureHelpTip component={(inline && InlineHelpTip) || TransferHelpTip}>
          <>
            <header>{t("##.Upload.HereIsYourShareLink")}</header>
            {!shareUrl && <div>{t("##.Upload.LinkBeingGenerated")}</div>}
            {shareUrl && (
              <div>
                <SimpleLink href={shareUrl}>{shareUrl}</SimpleLink>
                <Paragraph>
                  <CopyToClipboard text={shareUrl}>
                    <button>
                      <i className="icon-copy" />
                    </button>
                  </CopyToClipboard>
                </Paragraph>
              </div>
            )}
          </>
        </ClickCaptureHelpTip>
      )}
      {!isSharedLink && !hasSubscription && isFinished && (
        <ClickCaptureHelpTip promo={true} component={(inline && InlineHelpTip) || TransferHelpTip}>
          <Paragraph>{t("##.Upload.UpgradeToProPromotion")}</Paragraph>
          <Paragraph>
            <TxlGhostButton as={Link} to={getRoute("/plans", language)}>
              {t("##.Upload.UpgradeToPro")}
            </TxlGhostButton>
          </Paragraph>
        </ClickCaptureHelpTip>
      )}
    </WrapperComponent>
  )
}

const mapStateToProps = state => {
  return {
    hasSubscription: state.login.hasSubscription,
  }
}

export default connect(mapStateToProps)(ConfirmedTransferHelpTips)
